(function () {
  'use strict';

  var STORAGE_KEY = 'lcm_vehicle_state_v1';


  function getActiveVehicle() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);

      if (!raw) return null;

      var state = JSON.parse(raw);

      if (
        !state ||
        !state.activeVehicle ||
        !state.activeVehicle.make ||
        !state.activeVehicle.model
      ) {
        return null;
      }

      return {
        make: String(state.activeVehicle.make).trim(),
        model: String(state.activeVehicle.model).trim()
      };

    } catch (error) {
      return null;
    }
  }


  function updateTitle() {
    var vehicle = getActiveVehicle();

    if (!vehicle) return;

    var vehicleName =
      vehicle.make + ' ' + vehicle.model;

    var title = document.title;


    /*
     * Nederlands
     */
    title = title.replace(
      /voor jouw auto/i,
      'voor jouw ' + vehicleName
    );


    /*
     * Engels
     */
    title = title.replace(
      /for your vehicle/i,
      'for your ' + vehicleName
    );


    /*
     * Duits
     */
    title = title.replace(
      /für dein Fahrzeug/i,
      'für dein ' + vehicleName
    );


    document.title = title;
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateTitle
    );
  } else {
    updateTitle();
  }

})();